import React,  {useState, useEffect, useRef, useCallback} from 'react';
import { useLocation } from 'react-router-dom'
import NovelCovid from 'novelcovid';
import ReactTooltip from "react-tooltip";

import SwipeableViews from 'react-swipeable-views';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import Level from '../../components/databanner/Level';
import GridItem from "../../components/grid/GridItem.js";
import GridContainer from "../../components/grid/GridContainer.js";
import TimeChart from "../../components/charts/TimeChart";
import { LoadingText, LoadingGraph } from '../../utils/Loading';
import MapChart from "../../components/maps/MapChart";

import { useSelector, useDispatch } from 'react-redux';

import {SET_TAB_INDEX} from '../../redux/types';

const useStyles = makeStyles(theme => ({

})) 



const Country = (props) => {
const classes = useStyles();
const locs = useLocation();
const tabIndex = useSelector(state => state.data.tabIndex);

const track = new NovelCovid();
const dispatch = useDispatch();
const theme = useTheme();

const [test, setTest] = useState({});
const [fetched, setFetched] = useState(false);
const [data, setData] = useState({});
 const [content, setContent] = useState("");

/* 
   useEffect(() => {
    
      getCountryData();
      getTest();
   
    
  }, [locs]);

  */

   useEffect(() => {
    const fetchData = async () => {
      const str = locs.pathname.substring(17);
      let [today, yesterday, historical] = await Promise.all([
        (
          await fetch(`https://corona.lmao.ninja/v2/countries/${str}`)
        ).json(),
        (
          await fetch(
            `https://corona.lmao.ninja/v2/countries/${str}?yesterday=1`
          )
        ).json(),
        (
          await fetch(
            `https://corona.lmao.ninja/v2/historical/${str}?lastdays=all`
          )
        ).json(),
      ]);
      setData({
        data: today,
        yesterdayData: yesterday
      });

      setTest(historical)
      setFetched(true);
    }
     fetchData();
  }, [locs])


 const getCountryData = async () => {
    try {
      const str = locs.pathname.substring(17);
      const response = await track.countries(str)
      const yest = await track.countries(str,{yesterday: true});

       setData({data: response, yesterdayData: yest})

       setFetched(true);
      } catch (err) {
      console.log(err);
    }
  };

 const getTest = async () => {
    try {
      const str2 = locs.pathname.substring(17);
      const response = await track.historical(null, str2);
       setTest(response);
       //setFetched(true);
      } catch (err) {
      console.log(err);
    }
  }

  const handleChangeIndex = (index) => {
    dispatch({type: SET_TAB_INDEX, payload: index})
  };


  return (
      <div className={classes.container}>
       <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={tabIndex}
        onChangeIndex={handleChangeIndex}
      >
      { (tabIndex == 0 || !tabIndex) && <> <GridContainer role="tabpanel" dir={theme.direction} >
        <GridItem  xs={12} sm={10} md={6}>
         { fetched ? <Level data={data} /> : <LoadingText />}
        </GridItem>
      </GridContainer>
        
        <GridContainer >
        {fetched && test.timeline ? <TimeChart title="Confirmed" color="danger"   data={test.timeline.cases}/> :  <LoadingGraph /> }
        {fetched && test.timeline ? <TimeChart title="Recovered" color="success" cases={data.data.cases} diff={data.data.recovered} data={test.timeline.recovered}/> : <LoadingGraph /> }
        {fetched && test.timeline ? <TimeChart title="Deceased" color="gray" cases={data.data.cases} diff={data.data.deaths} data={test.timeline.deaths}/> : <LoadingGraph /> }
       </GridContainer> </>}
      
       {tabIndex == 1 &&  <GridContainer role="tabpanel" dir={theme.direction}><GridItem xs={12} sm={10} md={10}> <MapChart setTooltipContent={setContent}/> </GridItem></GridContainer>  }

       </SwipeableViews>
      { tabIndex == 1 && <ReactTooltip>{content}</ReactTooltip>} 
      </div>
  );
}
// {JSON.stringify(test)}
export default Country;